import React from 'react';
export function StatusBadge({
  status
}) {
  const statusConfig = {
    'Under Review': {
      color: 'bg-yellow-100 text-yellow-800',
      text: 'Under Review'
    },
    Approved: {
      color: 'bg-green-100 text-green-800',
      text: 'Approved'
    },
    Flagged: {
      color: 'bg-red-100 text-red-800',
      text: 'Flagged'
    }
  };
  const config = statusConfig[status] || statusConfig['Under Review'];
  return <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${config.color}`} data-id="element-109">
      {config.text}
    </span>;
}